import useInView from '@propertypal/shared/src/hooks/useInView';
import currencyDirect from '@propertypal/shared/src/resources/logos/currencies-direct-logo-dark.png';
import { trackGaEvent } from '@propertypal/shared/src/services/analytics';
import { Property } from '@propertypal/shared/src/types/property';
import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import React, { FunctionComponent, useRef } from 'react';
import { Container } from './CurrencyDirectAd.style';

interface Props {
  property: Property;
}

const canShow = (property: Property) => {
  if (!property.price || property.price.priceOnApplication) return false;
  if (property.saleType.key === 'rent') return false;
  if (property.featuredDevelopmentContent) return false;
  if (property.properties) return false;

  return true;
};

const CurrencyDirectAd: FunctionComponent<Props> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useInView(containerRef, { threshold: 0.5 }, () => {
    trackGaEvent('currency_direct_ad_impression', {
      location: 'PDP',
    });
  });

  const trackClick = () => {
    trackGaEvent('currency_direct_ad_click', {
      location: 'PDP',
    });
  };

  if (!canShow(props.property)) {
    return null;
  }

  return (
    <Container ref={containerRef}>
      <img src={currencyDirect.src} alt="Currencies Direct" />

      <p>
        <b>{platform.title} Currency Partner</b> - helping you transfer money for property purchases in Ireland &
        Northern Ireland.{' '}
        <Link href="/currency-transfers" onClick={trackClick}>
          Speak to an expert
        </Link>
      </p>
    </Container>
  );
};

export default CurrencyDirectAd;
